import { BUILD_YOUR_OFFER_SECTIONS } from '@makemydeal/dr-sales-checkin-types';
import type { ShowroomSectionKey } from '@makemydeal/dr-sales-checkin-types';

const SHOWROOM_SECTION_KEYS: ReadonlyArray<string> = BUILD_YOUR_OFFER_SECTIONS.map(({ key }) => key);

/** Narrows an arbitrary nav-item key to one of the four sections the page can render. */
export const isShowroomSectionKey = (key: string): key is ShowroomSectionKey => SHOWROOM_SECTION_KEYS.includes(key);

/**
 * The section a pathname belongs to, or `undefined` for an address that is not a section.
 * Segment-aware, so `/showroom/trade-in/takeover` resolves to `tradeIn` while
 * `/showroom/trade-inventory` resolves to nothing.
 */
export const sectionKeyFromPathname = (pathname: string): ShowroomSectionKey | undefined =>
    BUILD_YOUR_OFFER_SECTIONS.find(({ path }) => pathname === path || pathname.startsWith(`${path}/`))?.key;
